import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { CakeItEasyWebUiModule, UiOutletsMapMobileComponent } from '@cakeiteasy/web-ui';
import { NgCakeItEasyUtilsModule } from '@cakeiteasy/web-utils';
import { NgBusyModule } from 'ng-busy';
import { BuildCakeModalComponent } from './build-cake-modal/build-cake-modal.component';
import { OutletsMapModalComponent } from './outlets-map-modal/outlets-map-modal.component';
import { UserAuthModalComponent } from './user-auth-modal/user-auth-modal.component';
import { UiModule } from '../ui/ui.module';
import { CartResetWarningModalComponent } from './cart-reset-warning-modal/cart-reset-warning-modal.component';
import { ModalOpenerService } from './modal-opener.service';
import { UsersUiModule } from '../users-ui/users-ui.module';
import { ContactUsModalComponent } from './contact-us-modal/contact-us-modal.component';
import { HowItWorksModalComponent } from './how-it-works-modal/how-it-works-modal.component';
import {
  CakeBuilderModule,
  CakesOverviewModule,
  RequestFormProductViewModule,
  UsersAuthModule
} from '@cakeiteasy/order-process';
import { HiwBakeryRowComponent } from './how-it-works-modal/components/hiw-bakery-row/hiw-bakery-row.component';
import { DeliveryPriceCheckModalComponent } from './delivery-price-check-modal/delivery-price-check-modal.component';
import { ScrollToModule, ScrollToService } from '@nicky-lenaers/ngx-scroll-to';
import { ThirdPartyInfoModalComponent } from '@modals/third-party-info-modal/third-party-info-modal.component';

const COMPONENTS = [
  CartResetWarningModalComponent,
  BuildCakeModalComponent,
  OutletsMapModalComponent,
  UserAuthModalComponent,
  ContactUsModalComponent,
  HowItWorksModalComponent,
  DeliveryPriceCheckModalComponent,
  ThirdPartyInfoModalComponent,
];

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    CakeBuilderModule,
    NgBusyModule,
    CakeItEasyWebUiModule,
    UiOutletsMapMobileComponent,
    NgCakeItEasyUtilsModule,
    UiModule,
    UsersUiModule,
    UsersAuthModule,
    FormsModule,
    CakesOverviewModule.forRoot(),
    RequestFormProductViewModule,
  ],
  exports: [
    ...COMPONENTS,
  ],
  declarations: [
    ...COMPONENTS,
    HiwBakeryRowComponent,
  ]
})
export class ModalsModule {
  static forRoot(): ModuleWithProviders<ModalsModule> {
    return {
      ngModule: ModalsModule,
      providers: [
        ModalOpenerService,
        ScrollToService,
      ]
    };
  }
}
